import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import _toInteger from 'lodash/toInteger';

import { AuthorizationRequestType } from '../../core/api/clients';
import { CabinEventReportDataProvider } from '../../core/context/CabinEventReportDataContext';
import { CabinEventFieldOptionsProvider } from '../../core/context/CabinEventFieldsOptionsContext';

function CabinEventFormLayout() {
  const { formId } = useParams<'formId'>();
  const { action } = useParams<'action'>();

  let requestType = AuthorizationRequestType.Contribute;
  if (action === 'approve') {
    requestType = AuthorizationRequestType.Approve;
  } else if (action === 'read') {
    requestType = AuthorizationRequestType.Read;
  }

  return (
    <div>
      <CabinEventReportDataProvider cabinEventReportId={_toInteger(formId)} role={requestType}>
        <CabinEventFieldOptionsProvider>
          <Outlet />
        </CabinEventFieldOptionsProvider>
      </CabinEventReportDataProvider>
    </div>
  );
}

export default CabinEventFormLayout;
